import utils from 'utils/lsp-utils-service';
import template from 'admin-reports/components/admin-reports-page/admin-reports-page.html';

const mapStateToThis = ({ session: { sidemenu } }) => ({
  sidemenu,
});

// eslint-disable-next-line no-undef
@Inject('$ngRedux')
class AdminReportsPageController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, null)(this);
  }

  $onInit() {
    this.pageHeader = utils.pageHeader(this.sidemenu, 'sref', 'retailerReports-admin');
  }

  $onDestroy() {
    this.unsubscribe();
  }
}

export default class AdminReportsPageComponent {
  constructor() {
    this.template = template;
    this.controller = AdminReportsPageController;
  }
}



// WEBPACK FOOTER //
// ./src/modules/admin-reports/components/admin-reports-page/admin-reports-page-component.js